// Supported UI languages. Stored on the user profile as a BCP-47 code.
// Only languages with a full dictionary in src/i18n are offered — add the
// dictionary first (see src/i18n/id/), then list the language here.
export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', native: 'English' },
  { code: 'id', label: 'Indonesian', native: 'Bahasa Indonesia' },
];

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_SELECT_OPTIONS = LANGUAGE_OPTIONS.map((l) => ({
  value: l.code,
  label: l.native === l.label ? l.label : `${l.label} · ${l.native}`,
}));

export function languageLabel(code) {
  const found = LANGUAGE_OPTIONS.find((l) => l.code === code);
  return found ? found.native : code;
}

/** Coerce a stored code to a supported one (users may have picked a language
 * that was offered before translations existed, e.g. "es"). */
export function normalizeLanguage(code) {
  return LANGUAGE_OPTIONS.some((l) => l.code === code) ? code : DEFAULT_LANGUAGE;
}
